import events from "./analytics-events";
import getEvents from "@utils/get-events-from-definition";

const EVENT_CATEGORY = "design_lab_actions";
const EVENT_CATEGORY_SUGARCUBE = "dyh_sugarcube";

const createBasicEvent = (action) => (label) => {
  return {
    event_category: EVENT_CATEGORY,
    event_action: action,
    event_label: label,
  };
};

const createSugarcubeEvent = (action) => (label) => {
  return {
    event_category: EVENT_CATEGORY_SUGARCUBE,
    event_action: action,
    event_label: label,
  };
};

const createSugarcubeEvents = (eventArray) => {
  const eventObject = {};
  eventArray.forEach((currentEvent) => {
    const { ga: gaEvent } = getEvents(currentEvent);
    eventObject[gaEvent] = createSugarcubeEvent(gaEvent);
  });
  return eventObject;
};

const createBasicEvents = (eventArray) => {
  const eventObject = {};
  eventArray.forEach((currentEvent) => {
    const { ga: gaEvent } = getEvents(currentEvent);
    eventObject[gaEvent] = createBasicEvent(gaEvent);
  });
  return eventObject;
};

const roomActions = [
  events.openSavedRoom.action,
  events.deleteSavedRoom.action,
  events.renameSavedRoom.action,
  events.openRoom.action,
];

const sugarcubeActions = [
  events.sugarcubeAddProduct.action,
  events.sugarcubeAddToBag.action,
  events.sugarcubeAddRoomToBag.action,
  events.sugarcubeClose.action,
  events.sugarcubeGraphicsCheck.action,
  events.sugarcubeLoadComplete.action,
  events.sugarcubeMoveProduct.action,
  events.sugarcubeOpen.action,
  events.sugarcubeRemoveProduct.action,
  events.sugarcubeSave.action,
  events.sugarcubeView.action,
];

const eventTypeMap = {
  ...createSugarcubeEvents([...sugarcubeActions]),
  ...createBasicEvents([
    ...roomActions,
    events.customerFeedbackEvent.action,
    events.navigationEvent.action,
    events.pageView.action,
    events.roomPageEvent.action,
    events.createRoomEvent.action,
    events.signInEvent.action,
    events.styleQuizEvent.action,
    events.faqEvent.action,
  ]),
};

export default eventTypeMap;
